import { QueryString } from '~/utils';
import { get, post } from './agent';

// The OAuth consent endpoints are session-level, not workspace-scoped — the member chooses which
// workspace to connect as part of consenting.
const oauth = () => {
  // /api/www/oauth — the consent API. Distinct from /api/oauth, which is the authorization server
  // the MCP client talks to directly.
  const url = '/www/oauth';

  return {
    authorizationRequest: (query = {}) =>
      get(url.concat('/authorization-request', new QueryString(query).toString(true))),
    consent: (body) => post(url.concat('/consent'), body),

    // RFC 8628. The device is polling the token endpoint; these only move the member's decision.
    deviceRequest: (query = {}) => get(url.concat('/device', new QueryString(query).toString(true))),
    deviceDecision: (body) => post(url.concat('/device'), body),
  };
};

export default oauth;
